module.exports = __webpack_public_path__ + "static/img/Daily Chassis Cab 360.0e2bafb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/videodaily/Daily Chassis Cab 360.jpg
// module id = Nyr+
// module chunks = 1